function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="23" height="17" viewBox="0 0 23 19" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path fill="#D71414" d="M10.873 19V2H.175z" /><path fill="#870707" d="M10.873 19V2H21.57z" /></g></svg>;
});